import '@ant-design/compatible/assets/index.css';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import Payout from '~pages/dashboard/referral/payout/list';
import { connect } from 'react-redux';
import * as accountActions from '~actions/account';

const mapStateToProps = state => {
  const account = state.dashboard.account?.toJS();
  const auth = state.auth.get('auth');

  return {
    cmsUser: account.account,
    updateStatus: account.communication.update.status,
    auth,
  };
};

const mapDispatchToProps = dispatch => ({
  getCmsUser: onSuccess => {
    dispatch(accountActions.getCmsUser(onSuccess));
  },
  updateCmsUser: (params, onSuccess) => {
    dispatch(accountActions.updateAccount(params, onSuccess));
  },
});

@connect(mapStateToProps, mapDispatchToProps)
@withTranslation()
class PayoutPage extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    this.handleGetCmsUser();
  }

  handleGetCmsUser = () => {
    this.props.getCmsUser(res => {
      this.setState({
        loadingUserData: false,
        userInfo: res.cmsUser,
      });
    });
  };

  getCurrentRole = () => {
    if (
      this.props.auth &&
      this.props.auth.currentRoleSlug &&
      this.state.userInfo &&
      this.state.userInfo.userRoles
    ) {
      return this.state.userInfo.userRoles.find(
        role => role.slug === this.props.auth.currentRoleSlug,
      );
    }
    return null;
  };

  render() {
    const currentRole = this.getCurrentRole();
    return <Payout role={currentRole} />;
  }
}

export default PayoutPage;

PayoutPage.propTypes = {
  t: PropTypes.func,
  history: PropTypes.object,
  auth: PropTypes.shape({
    currentRoleSlug: PropTypes.string,
  }),
  cmsUser: PropTypes.object,
};

PayoutPage.defaultProps = {
  t: () => {},
  history: '',
  auth: {},
  cmsUser: {},
};
